import React, { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleDownloadResume = () => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/Selvarajan Last Resume.pdf`;
    link.download = 'Selvarajan Last Resume.pdf';
    link.click();
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-particles"></div>
      <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
        <div className="hero-text">
          <h3 className="hero-greeting">Hi, I'm</h3>
          <h1 className="hero-name">SELVARAJAN</h1>
          <h2 className="hero-title">Full Stack Developer</h2>
          <p className="hero-subtitle">
            Passionate about building scalable, modern applications that solve real-world problems
          </p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={handleDownloadResume}>
              <i className="fa fa-download"></i> Download Resume
            </button>
            <button className="btn-secondary" onClick={scrollToContact}>
              <i className="fa fa-envelope"></i> Contact Me
            </button>
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-image-wrapper">
            <img 
              src={`${process.env.PUBLIC_URL}/images/selva.jpg`} 
              alt="Selvarajan - Full Stack Developer"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
